<template>
  <div :id="content.idHTML" class="TODO:" :class="jel_getClassObject(content)">
    <EditableArea
      v-if="mixinEnvironnement_inEditor"
      :content="content.notification"
      :parentTemplateId="metadata['mgnl:template']"
    />
    <Notification v-else-if="contentNotification" :content="contentNotification"></Notification>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';
import Notification from '@/components/base/Notification';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'ListeNotification',
  components: { EditableArea, Notification },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  computed: {
    contentNotification() {
      // On cherche la première notification à afficher, null si aucune
      const aNodeTrouve = this.content.notification['@nodes'].find((aNode) => {
        return this.jel_isComponentVisible(this.content.notification[aNode]);
      });
      return aNodeTrouve ? this.content.notification[aNodeTrouve] : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
};
</script>

<style lang="scss" scoped></style>
